const BOM = "﻿";

const escapeCell = (value: string) =>
  /[",\r\n]/.test(value) ? `"${value.replaceAll('"', '""')}"` : value;

export function buildAiAssistantTableCsv(rows: string[][]): string {
  return BOM + rows.map((row) => row.map(escapeCell).join(",")).join("\r\n");
}
